const couponRoutes = [
  {
    path: '/offline-coupon',
    name: 'offline-coupon',
    component: () => import('@/views/coupon/offline-coupon'),
    meta: {
      needLogin: true
    }
  }
]

export default couponRoutes
